import React from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { removeInvestmentTypeFilter } from '../../../../actions/actions'

export default function InvestmentTypesFilters () {
  const investmentTypeFilters = useSelector(({ certFilters }) => certFilters.investmentTypes, shallowEqual)
  const dispatch = useDispatch()

  const onRemoveInvestmentTypeClick = (investmentTypeId) => {
    dispatch(removeInvestmentTypeFilter(investmentTypeId))
  }
  return (
    <div className='col-md-2'>
      {investmentTypeFilters.map((item, i) => {
        return (
          <span key={i} className='badge badge-pill badge-light' style={{ cursor: 'pointer' }} onClick={(e) => onRemoveInvestmentTypeClick(item.id)}>{item.name}
            <i key={i} className='mdi mdi-cancel' />
          </span>
        )
      })}
    </div>
  )
}
